import { createFileRoute, notFound } from '@tanstack/react-router';
import {
  InventoryProductDetailPage,
  merchantProductDetailQueryOptions,
  normalizeInventoryProductParams,
} from '@/features/inventory';

export const Route = createFileRoute('/_authed/inventory/$productId')({
  loader: ({ context, params }) => {
    const normalizedParams = normalizeInventoryProductParams(params);
    if (!normalizedParams) {
      throw notFound();
    }

    void context.queryClient.prefetchQuery(
      merchantProductDetailQueryOptions(normalizedParams.productId),
    );

    return normalizedParams;
  },
  component: InventoryProductDetailRouteComponent,
});

function InventoryProductDetailRouteComponent() {
  const { productId } = Route.useLoaderData();

  return <InventoryProductDetailPage productId={productId} />;
}
